
class PersistentListFilter {

    listType
    content

    constructor(listType) {
        this.listType = listType
        this.getContent()
    }

    hasFilter() {
        return this.content[this.listType] != undefined
    }

    retrieve() {
        return this.content[this.listType] || null
    }

    removeFilter() {
        delete this.content[this.listType]
        this.saveFilter()
    }

    getContent() {
        this.content = JSON.parse(localStorage.getItem('persistentFilter')) || {}
    }

    persistFilter(value) {
        this.content[this.listType] = value
        this.saveFilter()
    }

    saveFilter() {
        localStorage.setItem('persistentFilter', JSON.stringify(this.content));
    }
}

export { PersistentListFilter };
